import { useState } from "react";
import { undoSale } from "@/lib/sales";
import { RotateCcw, ChevronUp, ChevronDown } from "lucide-react";

// THE UNDO BAR (his plan, S2.2): every action taken here sits on it, newest first, each with its own Undo — there is
// no "are you sure?" anywhere. An undone action comes off the bar.
export function useUndoBar() {
  const [items, setItems] = useState([]);
  const push = (d) => d?.event_id && setItems((xs) => [{ id: d.event_id, message: d.message }, ...xs].slice(0, 20));
  const drop = (id) => setItems((xs) => xs.filter((x) => x.id !== id));
  return { items, push, drop };
}

export function UndoBar({ bar, after, testid = "sales-undo-bar" }) {
  const [open, setOpen] = useState(false);
  if (!bar.items.length) return null;
  const undo = async (id) => { if (await undoSale(id, after)) bar.drop(id); };
  const [first, ...rest] = bar.items;
  return (
    <div data-testid={testid} className="sticky bottom-3 z-20 rounded-xl border border-emerald-300 bg-emerald-50/95 backdrop-blur p-2 shadow-lg space-y-1.5">
      <UndoLine item={first} onUndo={undo} testid={`${testid}-0`} />
      {rest.length > 0 && (
        <button type="button" data-testid={`${testid}-earlier`} onClick={() => setOpen((v) => !v)}
          className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-900 px-1">
          {open ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronUp className="w-3.5 h-3.5" />}{open ? "Hide" : "Show"} {rest.length} earlier
        </button>
      )}
      {open && rest.map((it, i) => <UndoLine key={it.id} item={it} onUndo={undo} testid={`${testid}-${i + 1}`} />)}
    </div>
  );
}

function UndoLine({ item, onUndo, testid }) {
  const [busy, setBusy] = useState(false);
  return (
    <div data-testid={testid} className="flex items-center gap-3 text-sm text-emerald-950">
      <span className="flex-1 min-w-0">{item.message}</span>
      <button type="button" data-testid={`${testid}-undo`} disabled={busy}
        onClick={async () => { setBusy(true); await onUndo(item.id); setBusy(false); }}
        className="inline-flex items-center gap-1.5 h-11 px-4 rounded-lg border-2 border-emerald-700 bg-white text-emerald-800 font-bold hover:bg-emerald-100 disabled:opacity-40">
        <RotateCcw className="w-4 h-4" />Undo</button>
    </div>
  );
}
